import Head from "next/head"
import * as React from "react"

import { GetStaticPropsResult } from "next"
import Image from "next/image"
import Link from "next/link"
import classNames from "classnames"
import { DrupalFile, DrupalMedia, DrupalNode, JsonApiErrors } from "next-drupal"
import { drupal } from "lib/drupal"
import {

  getSearchIndexFromContext,
  deserialize,
  JsonApiSearchApiResponse,
  DrupalSearchApiFacet,
} from "next-drupal"
import { useRouter } from "next/router"

import { getGlobalElements } from "lib/get-global-elements"
import { useTranslation } from "next-i18next"
import { absoluteURL, formatDate } from "lib/utils"

import { Layout, LayoutProps } from "components/layout"
import siteConfig from "site.config"


const params = {
  fields: {
"file--file": "uri,resourceIdObjMeta"
  },
  filter: {

    "field_categorie":"2"


  },
  include: "field_tags, field_paragraphs, field_image, field_media_image.field_media_image",

 sort: "-field_d",
}

interface IndexPageProps {
  nodes: DrupalNode[];
  facets: DrupalSearchApiFacet[];
  menus: LayoutProps["menus"]; // Add this line
}



export default function IndexPage({  menus,   nodes,
  facets: initialFacets, }: IndexPageProps) {
    const router = useRouter()
    const [status, setStatus] = React.useState<"error" | "success" | "loading">()
    const [results, setResults] = React.useState<DrupalNode[]>(nodes)
    const [facets, setFacets] =
      React.useState<DrupalSearchApiFacet[]>(initialFacets)

    async function handleSubmit(event) {
      event.preventDefault()

      for (const filter of ["fulltext", "tags", "field_status"]) {
        if (event.target[filter]?.value != "") {
          params["filter"][filter] = event.target[filter]?.value
        }
      }

      setStatus("loading")
      const response = await fetch("/api/search/default_index", {
        method: "POST",
        body: JSON.stringify({
          deserialize: false,
          params,
        }),
      })

      if (!response.ok) {
        return setStatus("error")
      }

      setStatus("success")

      const json = await response.json()
      const results = deserialize(json) as DrupalNode[]

      setResults(results)

      if (results?.length) {
        setFacets(json.meta.facets)
      }
    }
  const { t } = useTranslation()




  return (
    <Layout meta={{ title: t("Comité d'histoire de la politique de la ville") }} menus={menus} >



      <div className="max-w-screen-2xl mx-auto container green">

      <div className="max-w-screen-xl mx-auto container py-10 ">
      <div className="inline-block w-100 pb-10 text-white titre text-5xl font-semibold  text-center">AGENDA</div>


<div className="grid gap-4">


  <form onSubmit={handleSubmit} className="mb-4">
    <input
      type="search"
      placeholder="Rechercher des évènements (min 4 characters)..."
      name="fulltext"
      className="relative block w-full col-span-5 mb-4 px-3 py-4 text-gray-900 placeholder-gray-500 border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-black focus:border-black focus:z-10 sm:text-sm"
    />
    <div className="flex">
      {facets.map((facet) => (
        <div key={facet.id} className="flex">

            <label
              htmlFor={`${facet.id}--any`}
              className="flex items-center p-2 mr-4 rounded-md shadow-sm bg-white text-base"
            >
              <input
                type="radio"
                id={`${facet.id}--any`}
                name={facet.path}
                className="mr-2"
                value=""
                defaultChecked
              />
              Tous
            </label>
            {facet.terms.map((term) => (
              <label
                key={term.url}
                htmlFor={`${facet.id}--${term.values.value}`}
                className="flex items-center rounded-md shadow-sm p-2 mr-4 bg-white text-base"
              >
                <input
                  type="radio"
                  id={`${facet.id}--${term.values.value}`}
                  name={facet.path}
                  value={term.values.value}
                  className="mr-2"
                  defaultChecked={term.values.active}
                />
                {term.values.label}{" "}

              </label>
            ))}

        </div>
      ))}
      <button
        type="button"
        className="flex justify-center w-24 px-4 py-2 mr-4 text-sm font-medium text-gray-600 bg-white border border-gray-500 rounded-md shadow-sm hover:bg-gray-200"
        onClick={() => {
          router.reload()
        }}
      >
        Effacer
      </button>
      <button
        type="submit"
        data-cy="btn-submit"
        className="flex justify-center w-24 px-4 py-2 text-sm font-medium text-white bg-black border border-transparent rounded-md shadow-sm hover:bg-black"
      >
        {status === "loading" ? "Please wait..." : "Chercher"}
      </button>
    </div>

  </form>
  {status === "error" ? (
    <div className="px-4 py-2 text-sm text-red-600 bg-red-100 border-red-200 rounded-md">
      An error occured. Please try again.
    </div>
  ) : null}

  {!results.length ? (
    <span className="text-sm" data-cy="search-no-results">
      No results found.
    </span>
  ) : (
    <div className="">
      <div className="1">
        {results.map((node) => (
          <div key={node.id}     className="  mb-5  bg-white  shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
>

            <span
              className="grid grid-cols-7 gap-8 xs:grid-cols-1 rounded-md shadow-sm"
              data-cy="search-result"
            >


            {node.field_image?.uri.url?.length ? (
                            <>


                            <div className="col-span-6 sm:col-span-2 gap-0">
                            <Link href={node.path.alias}  passHref>
  <Image
  src=  {absoluteURL(node.field_image.uri.url)}
  alt={node.title || "Image"}
  title={node.title}
  priority={true}
  width={300}
  height={250}
style={{
    objectFit: "contain", // Maintient les proportions
    height: "250px",      // Contraint la hauteur
    width: "auto",        // Ajuste automatiquement la largeur en fonction de la hauteur
    maxHeight: "250px",   // Limite la hauteur maximale
        margin: "0 auto",     // Ajoute mx-auto pour centrer l'image horizontalement

  }}  // Maintient les proportions
/>



                            </Link>

                            </div>



                            </>
                            ) : (
                            <>

                            {node.field_media_image && (
                              <div className="col-span-6 sm:col-span-2 gap-0">
                              <Link href={node.path.alias}  passHref>

                                <Image
                                 src=  {absoluteURL(node.field_media_image.field_media_image.uri.url)}
                                 width={300}
                                 height={250}
                                 layout="responsive"
style={{ objectFit: "cover" }}

                                 alt={node.title}
                                 priority
                                />

                              </Link>

                              </div>
                            )}
                            </>
                            )}

              <div className="col-span-7 sm:col-span-5">
<div className="green text-white inline-block p-4 mb-4">
              {node.field_paragraphs.slice(0,1).map((dates) => (
                             <div key={dates.id} >
{formatDate(dates.field_d?.value)} - {formatDate(dates.field_d?.end_value)}
            <br/>
              {dates.field_localisation?.locality}

                             </div>
                           ))}
                           </div>
              {node.title && (
                <div
                  dangerouslySetInnerHTML={{ __html: node.title }}
                  className=" text-3xl  mb-4 text-gray-600 hover:text-gray-900 w-100"
                />

              )}

              {node.field_tags?.length? (
                              <>

                              {node.field_tags.map((cat) => (
                                             <div key={cat.id}>


{cat.name}

                                             </div>
                                           ))}


                              </>
                              ) : (
                              <>


                              </>


                              )}

              {node.body && (
                <span
                  dangerouslySetInnerHTML={{ __html: node.body.summary }}
                  className="prose-lg  mx-auto mb-4 text-gray-600"
                />
              )}




  </div>

            </span>
          </div>
        ))}
      </div>
    </div>
  )}




</div>

</div>






      </div>

    </Layout>
  );
}
export async function getStaticProps(
  context
): Promise<GetStaticPropsResult<IndexPageProps>> {
  const results = await getSearchIndexFromContext<JsonApiSearchApiResponse>(
    "default_index",
    context,
    {
      deserialize: false,
      params,
    }
  )

  return {
    props: {
      ...(await getGlobalElements(context)),

      nodes: deserialize(results) as DrupalNode[],
      facets: results.meta.facets,
    },
       revalidate: 5, // In seco
  }
}
